export function getQuestionnaireCardTitle(label: string, isLifestyleQuestionnaire?: boolean) {
    if (isLifestyleQuestionnaire) {
        return 'Een paar extra vragen';
    }

    return label === 'ess' ? 'Hoe slaperig ben je overdag?' : 'Welke klachten ervaar je?';
}
